import React from 'react'
import {FaGithub} from 'react-icons/fa'
import {Link} from 'react-router-dom'
import { PropTypes  } from 'prop-types'
function Navbar({title}) {
  return (
      <nav className=" font-[serif] navbar mb-10 bg-zinc-800 text-cyan-100 shadow-lg hover:shadow-cyan-500/50">
        <div className="container mx-auto">
          <div className="flex-none px-2 mx-2">
            <FaGithub className="inline pr-2 text-3xl"></FaGithub>
            <Link to='/' className='text-lg gont-bold align-middle'>
              {title}
            </Link>
          </div>
          <div className="flex-1 px-2 mx-2">
            <div className="flex justify-end">
              <Link to='/' className='btn btn-ghost btn-sm rounded-btn'>
                Home
              </Link>
              <Link to='/about' className='btn btn-ghost btn-sm rounded-btn'>
                About
              </Link>
            </div>
          </div>
        </div>
      </nav>
  )
}
Navbar.defaultProps = {
    title: 'Github Miner'
}
Navbar.propTypes ={
    title: PropTypes.string
}

export default Navbar